const handleCollection = (): Record<string, unknown> => ({
    keyArgs: (keys: any) => Object.keys(keys).filter(k => k !== 'start' && k !== 'limit'),
    merge(existing: any, incoming: any) {
        if (!existing || incoming?.meta?.range?.from === 1) {
            return incoming
        }

        return {
            ...incoming,
            // Eine Seite ohne `collection` ist kein Fehler, sondern eine leere
            // Seite — der Bestand kennt das und fragt an anderer Stelle mit
            // `collection?.length` nach. Ungeschuetzt gespreizt beendet sie
            // dagegen die ganze Seite mit "Spread syntax requires ...iterable
            // not be null or undefined", und zwar aus dem Cache heraus, also
            // weit weg von der Abfrage, die sie ausgeloest hat.
            collection: [
                ...(existing.collection ?? []),
                ...(incoming?.collection ?? []),
            ],
            // Die zusammengefuegte Liste beginnt beim Anfang der schon
            // vorhandenen Seite und endet am Ende der neuen. `from` sass bisher
            // eine Ebene zu hoch — `meta` hat kein `from`, nur `range` hat eins.
            // Der Ausdruck war damit immer `undefined`, und `range.from` blieb
            // der Anfang der *letzten* Seite statt der ersten.
            meta: {
                ...incoming?.meta,
                range: {
                    ...incoming?.meta?.range,
                    from: existing.meta?.range?.from,
                },
            },
        }
    },
})

export default handleCollection
